import { mutation_add_log } from "../mutations/logMutations";
import sharedDatasInstance from "../sharedDatas";
import { useMutation } from "@1f/react-sdk";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";

export const LogApi = () => {
    
    const errorApiHelpers = apiErrorHelper();
    const apiAddLog = useMutation(
        mutation_add_log, 
        { graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    );

    const AddLog = (message, stack, method,area ,level = "ERROR") => {
        let tenantId = sharedDatasInstance.getPropertyByName("tenantId");
        let aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
        let version = sharedDatasInstance.getPropertyByName("version");
        if(!tenantId){
            tenantId = null;
        }
        if(!aziendaId){
            aziendaId = null;
        }
        if(!version){
            version = null;
        }
        try {
            apiAddLog.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                level: level,
                message: message,
                stack: stack,
                area: area,
                method: method,
                version: version,
            });
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            console.error("Errore durante l'invio del log:", errorMessage || error);
        }
    };

    return {
        AddLog
    };
}